import type { TypographyProps } from "@mui/material";
import Alert, { type AlertProps } from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Link, { type LinkProps } from "@mui/material/Link";
import Stack, { type StackProps } from "@mui/material/Stack";
import { styled } from "@mui/material/styles";
import imageRunners from "@repo/ui/assets/images/runners.png";
import { BodyTextM, HeadingM } from "../Typography";

export const BannerAlert = styled((props: AlertProps) => <Alert icon={false} severity={undefined} {...props} />)(
    ({ theme }) =>
        theme.unstable_sx({
            flexDirection: "row-reverse",
            py: 3,
            px: 4,
            boxShadow: "far",
            border: "1px solid",
            borderColor: "grey.light",
            bgcolor: "white.main",
            ".MuiAlert-message": { flexGrow: 1 },
        }),
);

export const BannerHeadingGroup = styled(Box)(({ theme }) =>
    theme.unstable_sx({
        mb: 3,
    }),
);

export const BannerHeading = styled((props: TypographyProps) => <HeadingM scaleDown {...props} />)(({ theme }) =>
    theme.unstable_sx({
        display: "inline-block",
        mb: 0,
    }),
);

export const BannerTextStack = styled((props: StackProps) => <Stack mb={0} spacing={2} {...props} />)(({ theme }) =>
    theme.unstable_sx({
        color: "grey.dark",
        mb: theme.spacing(2),
    }),
);

export const BannerText = styled((props: TypographyProps) => <BodyTextM component="p" {...props} />)(({ theme }) =>
    theme.unstable_sx({
        textAlign: "left",
    }),
);

export const TextLine = styled("span")(({ theme }) => ({
    "&:not(:last-child)::after": {
        content: '" "',
    },
    [theme.breakpoints.up("md")]: {
        display: "block",
        "&:not(:last-child)::after": {
            content: "none",
        },
    },
}));

export const StrongText = styled("span")({
    fontWeight: 600,
});

export const BannerTextWithPadding = styled((props: TypographyProps) => <BodyTextM component="p" {...props} />)(
    ({ theme }) =>
        theme.unstable_sx({
            textAlign: "left",
            [theme.breakpoints.up("md")]: {
                pr: "170px",
            },
        }),
);

export const BannerLink = styled((props: LinkProps) => (
    <Link underline="none" target="_blank" rel="noopener noreferrer" {...props} />
))(({ theme }) =>
    theme.unstable_sx({
        color: "#EA650D",
        fontWeight: 600,
    }),
);

export const MailtoLink = styled("a")(({ theme }) =>
    theme.unstable_sx({
        color: "primary.main",
    }),
);

export const BackgroundImageWrapper = styled("div")<{ $isDesktop: boolean }>(({ $isDesktop }) => ({
    backgroundImage: `url("${imageRunners}")`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "150px 100px",
    backgroundPosition: $isDesktop ? "right bottom" : "top left",
    paddingTop: $isDesktop ? undefined : "100px",
    width: "100%",
    height: "100%",
}));
